import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { NavLink, useLocation } from "react-router-dom";
import MyContext from "../MyContext";
import logoImage from "../images/MSG Notifier1.svg";
import LogoutImage from "../images/logout.svg";
import "./DesktopNav.css";

const InternalNav = ({ services, commonMinimized }) => {
  const location = useLocation();

  return (
    <div className={`internal-nav ${commonMinimized ? "minimized" : ""}`}>
      <div
        className="m-0 mt-4 d-flex justify-content-end pb-4"
        style={{ borderBottom: "1px solid #E8E2E2" }}
      >
        <button
          className="px-3 py-2"
          style={{ border: 0, borderRadius: "10px 0px 0px 10px" }}
        >
          {commonMinimized ? "🡪" : "🡨"}
        </button>
      </div>

      <div className="nav-links2 mt-4">
        {services?.map((service) =>
          service?.service_url ? (
            <NavLink
              key={service.id}
              to={service.service_url}
              className={`navlink-height ${
                location.pathname === service.service_url ? "internal-link" : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              <div
                className={`d-flex flex-column align-items-center ${
                  commonMinimized ? "my-2 mx-3" : "m-3"
                }`}
              >
                {service.service_active_icon && (
                  <img
                    src={service.service_active_icon}
                    alt={service.service_name}
                    width={20}
                  />
                )}

                {commonMinimized && (
                  <div className="nav-text text-center single-line-css">
                    {service.service_name}
                  </div>
                )}
              </div>

              {!commonMinimized && service.service_name}
            </NavLink>
          ) : null,
        )}
      </div>
    </div>
  );
};

const NavigationBar = ({ handleLogout, userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const location = useLocation();

  const [modules, setModules] = useState([]);
  const [commonMinimized, setCommonMinimized] = useState(
    () => JSON.parse(sessionStorage.getItem("commonMinimized")) ?? true,
  );

  useEffect(() => {
    sessionStorage.setItem("commonMinimized", JSON.stringify(commonMinimized));
  }, [commonMinimized]);

  useEffect(() => {
    const fetchSidebar = async () => {
      try {
        const res = await axios.post(
          `${baseUrl}/api/Entitlement/v1.0/fetchEntitlementModuleDetails`,
          { userid: userID },
          config,
        );

        if (res.data.responseCode === "00") {
          const priorityOrder = ["dashboard", "whatsapp", "settings"];

          const sortedModules = [...res.data.data].sort((a, b) => {
            const aName = a.module_name?.toLowerCase();
            const bName = b.module_name?.toLowerCase();

            const aIndex = priorityOrder.indexOf(aName);
            const bIndex = priorityOrder.indexOf(bName);

            if (aIndex === -1 && bIndex === -1) return 0;

            if (aIndex === -1) return 1;

            if (bIndex === -1) return -1;

            return aIndex - bIndex;
          });

          setModules(sortedModules);
        }
      } catch (err) {
        console.error("Sidebar API error", err);
      }
    };

    fetchSidebar();
  }, [userID]);

  const activeModule = modules.find((m) =>
    location.pathname.startsWith(m.module_url),
  );

  return (
    <>
      <div className="sidebar py-5 h-100">
        <div>
          <div className="logo d-flex justify-content-center mb-1 ps-2">
            <img src={logoImage} height={50} alt="Logo" />
          </div>

          <div className="d-flex flex-column justify-content-start">
            {modules.map((module) => (
              <div key={module.id} className="nav-link-container">
                <NavLink
                  to={module.module_url}
                  className="d-block link navlink-height d-flex flex-column"
                >
                  <img
                    src={
                      location.pathname.startsWith(module.module_url)
                        ? module.module_selected_icon
                        : module.module_active_icon
                    }
                    width={20}
                    height={20}
                    alt={module.module_name}
                  />
                  <div className="nav-text">{module.module_name}</div>
                </NavLink>

                {location.pathname.startsWith(module.module_url) &&
                  module.module_name?.toLowerCase() !== "dashboard" && (
                    <InternalNav
                      services={module.services}
                      commonMinimized={commonMinimized}
                    />
                  )}
              </div>
            ))}
          </div>
        </div>

        <div className="w-100">
          <div
            className="link cursor-pointer d-flex flex-column"
            onClick={handleLogout}
          >
            <img src={LogoutImage} width={20} alt="Logout" />
            <div className="nav-text">Logout</div>
          </div>
        </div>
      </div>

      <div
        className={`content-nav ${
          activeModule ? "content-internal-nav-open" : ""
        }`}
      />
    </>
  );
};

export default NavigationBar;
